import { makeAutoObservable, runInAction, reaction } from "mobx"
import {authApi} from "../api/auth.js";
import jwtDecode from "jwt-decode";
import {taxAuthApi} from "../api/taxAuth.js";

export class TaxAuthOnboardingStore {
    inviteKey = null;
    taxAuthName = null;
    stripeOnboardingLink = null;
    organizationId = null;
    firstName = null;
    lastName = null;
    password = null;
    financialOnboardingComplete = false;

    taxAuthApi = null;
    constructor(taxAuthApi) {
        makeAutoObservable(this);
        this.taxAuthApi = taxAuthApi;
    }

    async getTaxAuthAPIInfo(inviteKey) {
        const info = await taxAuthApi.getOnboardingInfo(inviteKey);
        runInAction(() => {
            this.inviteKey = inviteKey;
            this.taxAuthName = info.taxAuthName;
            this.organizationId = info.organizationId;
            this.stripeOnboardingLink = info.stripeOnboardingLink;
        });
    }
}

